// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ChangeTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ChangeTypesQuery = { __typename?: 'Query', enumDetails: { __typename?: 'AllEnumDetails', changeType: Array<{ __typename?: 'ChangeTypeDetail', code: Types.ChangeType, name: string }> } };


export const ChangeTypesDocument = gql`
    query ChangeTypes {
  enumDetails {
    changeType {
      code
      name
    }
  }
}
    `;

/**
 * __useChangeTypesQuery__
 *
 * To run a query within a React component, call `useChangeTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useChangeTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChangeTypesQuery, ChangeTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChangeTypesQuery, ChangeTypesQueryVariables>(ChangeTypesDocument, options);
      }
export function useChangeTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChangeTypesQuery, ChangeTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChangeTypesQuery, ChangeTypesQueryVariables>(ChangeTypesDocument, options);
        }
// @ts-ignore
export function useChangeTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChangeTypesQuery, ChangeTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeTypesQuery, ChangeTypesQueryVariables>;
export function useChangeTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeTypesQuery, ChangeTypesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChangeTypesQuery | undefined, ChangeTypesQueryVariables>;
export function useChangeTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChangeTypesQuery, ChangeTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChangeTypesQuery, ChangeTypesQueryVariables>(ChangeTypesDocument, options);
        }
export type ChangeTypesQueryHookResult = ReturnType<typeof useChangeTypesQuery>;
export type ChangeTypesLazyQueryHookResult = ReturnType<typeof useChangeTypesLazyQuery>;
export type ChangeTypesSuspenseQueryHookResult = ReturnType<typeof useChangeTypesSuspenseQuery>;
export type ChangeTypesQueryResult = Apollo.QueryResult<ChangeTypesQuery, ChangeTypesQueryVariables>;